import React from 'react'
import PriceText from './PriceText';


export default function Price() {
    return (
        <div id="price" >
            <h1>الأسعار</h1>
            <PriceText />
        </div>
    )
}
